<template>
	<div>
		<b-overlay :show="is_load" rounded="sm">
			<div class="panel-tag">
				{{__t("CATEG_TAG_PRODUCTS")}}
			</div>

			<div class="catge_products_block">

				<b-table head-variant="dark"
						 :thead-class="head_class"
						 :tbody-tr-class="rowClass"
						 striped
						 :items="cat_prods"
						  class="table-responsive-xl resolution_table"
						 :fields="fields">

					<template  v-slot:cell(qty)="data" >
						<div class="form-group mt-2" style="max-width: 200px">
							<label class="form-label" for="advanced_price">
								{{__t("PROD_QUAL_CATEG")}}
							</label>

							<div class="input-group flex-nowrap">
								<div class="input-group-prepend">
								<span class="input-group-text">
									<i class="fal  fa-typewriter fs-xl" ></i>
								</span>
								</div>
								<input id="advanced_price" type="text" class="form-control" v-model="data.item.qty">
							</div>
						</div>
					</template>


					<template v-slot:cell(product)="data" >
						<div class="form-group mt-2" style="min-width: 350px">
							<label class="form-label" for="advanced_price">
								{{__t("PRODUCT")}}
							</label>

							<div class="input-group flex-nowrap">
								<v-select
										  v-model="data.item.product"
										  class="imc_reason form-controls"
										  label="title"
										  :searchable="true"
										  :filterable="true"
										  :options=products  >

									<template slot="option" slot-scope="option">
										<div class="d-center">

											<div >{{option.title}}</div>
											<div>
                                                <div>
                                                    <span class="small badge border border-info  text-info mr-1">
                                                        Uniq ID :{{ option.uniq_id }}
                                                    </span>
                                                </div>
												<div>
													<small>
														ID :{{ option.id }}
													</small>
												</div>
											</div>
										</div>
									</template>
								</v-select>
							</div>
						</div>
					</template>

					<template v-slot:cell(id)="data" >
						<i class="fal fa-trash cursor-pointer" v-on:click="remove(data.index)"></i>
					</template>

				</b-table>
			</div>

			<div class="add_button mt-2">
				<button type="button" v-on:click="push_empty" class="btn btn-lg btn-outline-primary waves-effect waves-themed">
					{{__t("ADD")}}
				</button>
			</div>
		</b-overlay>
	</div>
</template>

<script>
import vSelect from "vue-select";

export default {
	name: "categ_products",
	components : {
		vSelect
	},
	props : {
		categ : {
			type : Object
		}
	},
	data() {
		return {
			is_load: false,
			products : [],
			cat_prods : [],
			fields : [
				{
					key : 'product',
					label: this.__t("PRODUCT"),
					class:'prod_rest_restaurants'
				},

				{
					key : 'qty',
					label : this.__t('QTY'),
					class : 'prod_rest_price',
				},

				{
					key : 'id',
					label :' x ',
					class : 'prod_rest_id',
				},
			],
		}
	},
	beforeDestroy() {
		EventBus.$off('save_categ_called',this.save_categ);
	},

	created() {
		this.load_product_choice();
		this.cat_prods = [];

		EventBus.$on("save_categ_called",this.save_categ)
	},

	mounted ( ) {

		if(this.categ.categ_products.length > 0) {
			this.categ.categ_products.map(itm => {
				this.cat_prods.push(itm);
			})
		}
	},

	methods : {

		async save_categ () {
			this.is_load = true;
			let self = this;

			let send = {
				"id" : this.categ.id,
				'relations' : this.cat_prods
			};
			await api.put('/internal/catalog/categories/' + parseInt(this.categ.id) + "/save_relations",{
				'category' :send
			}).then(({data}) => {
				this.is_load = false;
				if (data.status === "operation_success") {

				}
			}).catch(({response}) => {
				EventBus.$emit("categ_error_save",data.data);
				this.is_load = false;
				EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
			});
		},

		async load_product_choice() {
			this.is_load = true;
			this.products = [];
			await api.get('/internal/catalog/products').then(({data}) => {
				this.is_load = false;
				if (data.status === "operation_success") {
					this.products = data.data;
				}
			})
				.catch(({response}) => {
					this.is_load = false;
					this.products = [];
					EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
				});
		},

		rowClass(item) {

		},

		remove(arr_idx) {
			console.log("remove_item ->",arr_idx);
			this.cat_prods.splice(arr_idx,1);
		},

		push_empty() {
			let empty_rest = {
				id : 0,
				product : {"id" : 0,'title' : ""},
				qty : 0,
			};
			this.cat_prods.push(empty_rest);
		}
	},

	computed : {

		worked_data : {
			get: function () {
				return this.categ.categ_products;
			},
			set : function (val) {
				console.log(val);
				return this.categ.categ_products = val;
			}
		},


		head_class() {
			return 'hidden_heade';
		},
	}
}
</script>

<style scoped>

</style>
